const OVERVIEW_UPDATE_STATE = 'fulcrum/containers/Form/Memory/OVERVIEW_UPDATE_STATE'
const OVERVIEW_ADD_MEMORY = 'fulcrum/containers/Form/Memory/OVERVIEW_ADD_MEMORY'
const OVERVIEW_REFRESH_MEMORY = 'fulcrum/containers/Form/Memory/OVERVIEW_REFRESH_MEMORY'
const UPDATE_STATE_ENTIRE_OBJ = 'fulcrum/containers/Form/Memory/UPDATE_STATE_ENTIRE_OBJ'
const UPDATE_CLOCK_VALUE = 'fulcrum/containers/Form/Memory/UPDATE_CLOCK_VALUE'
const INIT_CONFIG = 'fulcrum/containers/Form/Memory/INIT_CONFIG'
const OPEN_MEMORY_BROWSER_WITH_FILTER = 'fulcrum/containers/Form/Memory/OPEN_MEMORY_BROWSER_WITH_FILTER'

const TOGGLE_POPUP = 'fulcrum/containers/Form/Memory/TOGGLE_POPUP'
const TOGGLE_FILTER = 'fulcrum/containers/Form/Memory/UPDATE_FILTER'
const UPDATE_CONFIG_SELECTION = 'fulcrum/containers/Form/Memory/UPDATE_CONFIG_SELECTION'
const UPDATE_CONFIG_SOURCE = 'fulcrum/containers/Form/Memory/UPDATE_CONFIG_SOURCE'
const INITIALIZE_FILTER = 'fulcrum/containers/Form/Memory/INITIALIZE_FILTER'
const INITIALIZE_CONFIG_FILTER = 'fulcrum/containers/Form/Memory/INITIALIZE_CONFIG_FILTER'
const ADD_CONFIG = 'fulcrum/containers/Form/Memory/ADD_CONFIG'
const DELETE_PART = 'fulcrum/containers/Form/Memory/DELETE_PART'
const REFRESH_FILTER = 'fulcrum/containers/Form/Memory/REFRESH_FILTER'
const IS_ADD_PART = 'fulcrum/containers/Form/Memory/IS_ADD_PART'

const PART_TYPE = 'fulcrum/containers/Form/Memory/PART_TYPE'
const DENSITY = 'fulcrum/containers/Form/Memory/DENSITY'
const ORG_SIZE = 'fulcrum/containers/Form/Memory/ORG_SIZE'
const ORG_WIDTH = 'fulcrum/containers/Form/Memory/ORG_WIDTH'
const CHANNEL = 'fulcrum/containers/Form/Memory/CHANNEL'
const CONFIG = 'fulcrum/containers/Form/Memory/CONFIG'
const UPDATE_CURRENT_CONFIG = 'fulcrum/containers/Form/Memory/UPDATE_CURRENT_CONFIG'

const configString = (partType, orgSize, orgWidth, density) => {
  return `${partType}, ${orgSize}Mx${orgWidth}, ${density}GB`
}

const RUN_RISK_VALIDATION = 'fulcrum/container/Form/Memory/RUN_RISK_VALIDATION'

export {
  configString,
  RUN_RISK_VALIDATION,
  OVERVIEW_UPDATE_STATE,
  OVERVIEW_ADD_MEMORY,
  OVERVIEW_REFRESH_MEMORY,
  UPDATE_STATE_ENTIRE_OBJ,
  UPDATE_CLOCK_VALUE,
  INIT_CONFIG,
  OPEN_MEMORY_BROWSER_WITH_FILTER,
  TOGGLE_POPUP,
  TOGGLE_FILTER,
  UPDATE_CONFIG_SELECTION,
  UPDATE_CONFIG_SOURCE,
  INITIALIZE_FILTER,
  INITIALIZE_CONFIG_FILTER,
  ADD_CONFIG,
  DELETE_PART,
  REFRESH_FILTER,
  IS_ADD_PART,
  PART_TYPE,
  DENSITY,
  ORG_SIZE,
  ORG_WIDTH,
  CHANNEL,
  CONFIG,
  UPDATE_CURRENT_CONFIG,
}
